<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <md-card>
          <md-card-header data-background-color="blue">
            <h4 class="title">Tribunal de Justicia JGMUN</h4>
            <p class="category">Módulo de imposición de penas y valoración de conducta procesal.</p>
          </md-card-header>
          <md-card-content>
            <sentencing-manager />
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import SentencingManager from "@/components/SentencingManager.vue";
export default { name: "SentencingPage", components: { SentencingManager } };
</script>